module.exports = __webpack_public_path__ + "static/media/1_A1_17.0ffd8e3f.png";